import React from 'react';
import { COLORS, Container } from '../../index';
import Icon from '../icon/Icon';
import ButtonIcon from '../icon/ButtonIcon';
import { mdiClose } from '@mdi/js';
var BannerCookies = function (_a) {
    var onClick = _a.onClick, className = _a.className, iconColor = _a.iconColor, iconPath = _a.iconPath, children = _a.children;
    return (React.createElement("div", { className: "banner " + (className || '') },
        React.createElement(Container, { className: 'banner-container' },
            React.createElement("div", { className: 'd-flex mr-x4' },
                iconPath && (React.createElement(Icon, { path: iconPath, color: iconColor, size: 2, className: 'icon-banner' })),
                React.createElement("div", { className: 'text-banner' }, children)),
            React.createElement(ButtonIcon, { iconPath: mdiClose, color: COLORS.white, size: 'md', title: 'Закрыть', hoverIconColor: 'white', isHoverArea: true, onClick: onClick }))));
};
export { BannerCookies };
//# sourceMappingURL=BannerCookies.js.map